import type {
  OrchestratorEffortSelection,
  OrchestratorModelSelection
} from '../slices/agent-orchestrator-slice'

/**
 * Effort to put on the orchestrator request. Auto omits the field so the
 * task-class policy applies. A pinned model sends the composer override,
 * or omits the field so the provider adapter default applies.
 */
export function effortForOrchestratorRequest(
  modelSelection: OrchestratorModelSelection | null,
  effortSelection: OrchestratorEffortSelection | null
): OrchestratorEffortSelection | null {
  if (modelSelection === null) return null
  return effortSelection
}
